import { __makeTemplateObject } from "tslib";
import styled from "../../redoc-lib/src/styled-components";
import { invertedInputStyles } from "../console/styled.components";
export var ServerUrl = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  border-radius: ", ";\n  padding: 7px 12px;\n  overflow-wrap: break-word;\n"], ["\n  ", ";\n  border-radius: ", ";\n  padding: 7px 12px;\n  overflow-wrap: break-word;\n"])), invertedInputStyles, function (e) {
  return e.theme.shape.borderRadius;
});
var templateObject_1;